const baseUrl = '/bills';
export const billsRoutes = {
  baseUrl: "".concat(baseUrl),
  billSettings: "".concat(baseUrl, "/bill-settings"),
  billSettingsV2: "".concat(baseUrl, "/bill-settings-v2")
};